import React, { useMemo } from "react";
import { useFormikContext } from "formik";
import { Col } from "components/bootstrap";
import { FormikInput, IconButton } from "components/common";
import { mappedUnitsFromJSON } from "views/components/visualizations/utils/unitConverters";
import ColorConfigurationPopover from "views/components/aggregationwizard/ColorConfigurationPopover";
const ThresholdFormItem = ({ metricIndex, thresholdIndex, onRemove }) => {
  const {
    values: { metrics, units },
    setFieldValue
  } = useFormikContext();
  const onColorSelect = (color) => setFieldValue(`metrics.${metricIndex}.thresholds.${thresholdIndex}.color`, color);
  const curColor = useMemo(
    () => {
      var _a, _b, _c;
      return (_c = (_b = (_a = metrics == null ? void 0 : metrics[metricIndex]) == null ? void 0 : _a.thresholds) == null ? void 0 : _b[thresholdIndex]) == null ? void 0 : _c.color;
    },
    [metricIndex, metrics, thresholdIndex]
  );
  const curUnitName = useMemo(() => {
    var _a;
    const field = (_a = metrics == null ? void 0 : metrics[metricIndex]) == null ? void 0 : _a.field;
    const unit = units == null ? void 0 : units[field];
    if (!(unit == null ? void 0 : unit.abbrev) || !(unit == null ? void 0 : unit.unitType)) return null;
    return mappedUnitsFromJSON[unit.unitType].find(({ abbrev }) => abbrev === (unit == null ? void 0 : unit.abbrev)).name;
  }, [metricIndex, metrics, units]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Col, { sm: 11 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      key: `metrics-${metricIndex}-thresholds-${thresholdIndex}-name`,
      id: "thresholdName",
      label: "Title",
      bsSize: "small",
      placeholder: "Specify threshold name",
      name: `metrics.${metricIndex}.thresholds.${thresholdIndex}.name`,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  )), /* @__PURE__ */ React.createElement(Col, { sm: 1 }, /* @__PURE__ */ React.createElement(IconButton, { size: "sm", onClick: onRemove, name: "delete", title: "Remove threshold" })), /* @__PURE__ */ React.createElement(Col, { sm: 11 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      key: `metrics-${metricIndex}-thresholds-${thresholdIndex}-value`,
      id: "thresholdValue",
      label: "Value",
      bsSize: "small",
      type: "number",
      placeholder: "Specify threshold value",
      name: `metrics.${metricIndex}.thresholds.${thresholdIndex}.value`,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: curUnitName && `Value is in ${curUnitName}s`
    }
  )), /* @__PURE__ */ React.createElement(Col, { sm: 1 }, /* @__PURE__ */ React.createElement(
    ColorConfigurationPopover,
    {
      onColorSelect,
      curColor,
      title: "Color configuration for threshold"
    }
  )));
};
export default ThresholdFormItem;
